import $http from '@/utils/httpRequest'
export default {
    namespaced: true,
    state:{
        agencyCodeList:[],//法人机构类别
        nationList:[],//国别地区
        industryCodeList:[],//国民经济行业分类
        orgCertTypeList:[],//法定代表人证件信息
        mainBankList:[],//所属银行
        unitPropertyList:[],//企业类型
        qualificationSerialList:[],//资质序列
        qualificationIndustryList:[],//资质行业
        qualificationProfessionalList:[],//资质专业
        qualificationLevelList:[],//资质等级
        certTypeList:[],//人员证书类别
        qualificationTypeList:[],//企业资质证书类别
        certLevelList:[],//执业资格类型
        projectCategoryList:[],//业绩项目类型
        enterpriseRewardTypeList:[],//企业奖励类型
        bankEffectList:[],//银行作用
        qualifySerialList:[],//人员执业资格类型
        qualifyLevelList:[],//职称等级
        jobTitleList:[],//岗位名称
        personnelRewardList:[],//人员奖励惩罚
        educationList:[],//最高学历

    },
    mutations:{
        setAgencyCodeList(state,data){
            state.agencyCodeList = data;
        },
        setNationList(state,data){
            state.nationList = data;
        },
        setIndustryCodeList(state,data){
            state.industryCodeList = data;
        },
        setOrgCertTypeList(state,data){
            state.orgCertTypeList = data;
        },
        setMainBankList(state,data){
            state.mainBankList = data;
        },
        setUnitPropertyList(state,data){
            state.unitPropertyList = data;
        },
        setQualificationSerialList(state,data){
            state.qualificationSerialList = data;
        },
        setQualificationIndustryList(state,data){
            state.qualificationIndustryList = data;
        },
        setQualificationProfessionalList(state,data){
            state.qualificationProfessionalList = data;
        },
        setQualificationLevelList(state,data){
            state.qualificationLevelList = data;
        },
        setCertTypeList(state,data){
            state.certTypeList = data;
        },
        setQualificationTypeList(state,data){
            state.qualificationTypeList = data;
        },
        setCertLevelList(state,data){
            state.certLevelList = data;
        },
        setProjectCategoryList(state,data){
            state.projectCategoryList = data;
        },
        setEnterpriseRewardTypeList(state,data){
            state.enterpriseRewardTypeList = data;
        },
        setBankEffectList(state,data){
            state.bankEffectList = data;
        },
        setQualifySerialList(state,data){
            state.qualifySerialList = data;
        },
        setQualifyLevelList(state,data){
            state.qualifyLevelList = data;
        },
        setJobTitleList(state,data){
            state.jobTitleList = data;
        },
        setPersonnelRewardList(state,data){
            state.personnelRewardList = data;
        },
        setEducationList(state,data){
            state.educationList = data;
        },
    },
    actions:{
        getAgencyCodeList({commit}){//获取法人机构类别
            $http.get('/ent/sysdict/getddl?type=10013').then(({data})=>{
                commit('setAgencyCodeList',data.data)
            })
        },
        getNationList({commit}){//获取国别地区
            $http.get('/ent/sysdict/getddl?type=guobiediqu').then(({data})=>{
                commit('setNationList',data.data)
            })
        },
        getIndustryCodeList({commit}){//获取国民经济行业分类
            $http.get('/ent/sysdict/getddl?type=ent_hnagyedaima').then(({data})=>{
                commit('setIndustryCodeList',data.data)
            })
        },
        getOrgCertTypeList({commit}){//法定代表人证件信息
            $http.get('/ent/sysdict/getddl?type=zhengjianleixing').then(({data})=>{
                commit('setOrgCertTypeList',data.data)
            })
        },
        getMainBankList({commit}){//获取所属银行
            $http.get('/ent/sysdict/getddl?type=ent_suoshuyinhang').then(({data})=>{
                commit('setMainBankList',data.data)
            })
        },
        getUnitPropertyList({commit}){//获取企业类型
            $http.get('/ent/sysdict/getddl?type=ent_qiyeleixing').then(({data})=>{
                commit('setUnitPropertyList',data.data)
            })
        },
        getQualificationSerialList({commit}){//获取资质序列
            $http.get('/ent/sysdict/getddl?type=22').then(({data})=>{
                commit('setQualificationSerialList',data.data)
            })
        },
        getQualificationIndustryList({commit}){//获取资质行业
            $http.get('/ent/sysdict/getddl?type=23').then(({data})=>{
                commit('setQualificationIndustryList',data.data)
            })
        },
        getQualificationProfessionalList({commit}){//获取资质专业
            $http.get('/ent/sysdict/getddl?type=24').then(({data})=>{
                commit('setQualificationProfessionalList',data.data)
            })
        },
        getQualificationLevelList({commit}){//获取资质等级
            $http.get('/ent/sysdict/getddl?type=25').then(({data})=>{
                commit('setQualificationLevelList',data.data)
            })
        },
        getCertTypeList({commit}){//获取人员证书类别
            $http.get('/ent/sysdict/getddl?type=ent_empzhengshuleibie').then(({data})=>{
                commit('setCertTypeList',data.data)
            })
        },
        getQualificationTypeList({commit}){//获取企业资质证书类别
            $http.get('/ent/sysdict/getddl?type=ent_zizhileibie').then(({data})=>{
                commit('setQualificationTypeList',data.data)
            })
        },
        getCertLevelList({commit}){//获取人员证书等级
            $http.get('/ent/sysdict/getddl?type=ent_aqsckhhgz_zsdj').then(({data})=>{
                commit('setCertLevelList',data.data)
            })
        },
        getProjectCategoryList({commit}){//获取业绩项目类型
            $http.get('/ent/sysdict/getddl?type=xiangmuleibie').then(({data})=>{
                commit('setProjectCategoryList',data.data)
            })
        },
        getQualifySerialList({commit}){//获取人员执业资格类型
            $http.get('/ent/sysdict/getddl?type=10067').then(({data})=>{
                commit('setQualifySerialList',data.data)
            })
        },
        getQualifyLevelList({commit}){//获取职称等级
            $http.get('/ent/sysdict/getddl?type=ent_zcz_dj').then(({data})=>{
                commit('setQualifyLevelList',data.data)
            })
        },
        getJobTitleList({commit}){//获取岗位名称
            $http.get('/ent/sysdict/getddl?type=ent_gwz_name').then(({data})=>{
                commit('setJobTitleList',data.data)
            })
        },
        getEnterpriseRewardTypeList({commit}){//获取业绩项目类型
            $http.get('/ent/sysdict/getddl?type=ent_jianglileixing').then(({data})=>{
                commit('setEnterpriseRewardTypeList',data.data)
            })
        },
        getBankEffectList({commit}){//获取银行作用
            $http.get('/ent/sysdict/getddl?type=yinghangzuoyong').then(({data})=>{
                commit('setBankEffectList',data.data)
            })
        },
        getPersonnelRewardList({commit}){//获取人员奖罚类型
            $http.get('/ent/sysdict/getddl?type=jianglihechufaleixing').then(({data})=>{
                commit('setPersonnelRewardList',data.data)
            })
        },
        getEducationList({commit}){//获取最高学历
            $http.get('/ent/sysdict/getddl?type=38').then(({data})=>{
                commit('setEducationList',data.data)
            })
        },
    }
}